import { Component, Prop, Vue } from 'vue-property-decorator';
import OnBoardingDot from './on-boarding-dot/OnBoardingDot.vue';

@Component({
  components: {
    OnBoardingDot
  }
})
export default class ProductTutorialDialog extends Vue {
  @Prop() slideIdx = 0;
  @Prop() nextSlide: () => void;
  @Prop() backSlide: () => void;
  @Prop() onClose: () => void;
  @Prop() onMoreClick: () => void;
}
